import styled from 'styled-components';

const TextInput = styled.input`
  color: #464444;
  width: 100%;
  height: 58px;
  box-shadow: none;
  position: relative;
  font-size: 16px;
  margin: 0;
  line-height: 24px;
  padding: 15px 20px;
  border: 2px solid #e1e1e1;
  // border-radius: 10px;
  background: #f3f3f3;
  &:focus {
    outline: none;
  }
`;

export default TextInput;



// WEBPACK FOOTER //
// ./app/containers/Login/components/TextInput/index.js